<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2>{{dialogTitle(dialogData.redeemType)}}</h2>
    <div class="ya-dialog-content">
      <mat-tab-group mat-stretch-tabs dynamicHeight="true" animationDuration="20ms" class="ya-tab-group"
        [disableRipple]="true" #matTabGroup>
        <mat-tab label="{{locationTabLabel}}">
          <div class="tab__description">
            <span>{{dialogDescription(dialogData.redeemType)}}</span>
          </div>
          <div class="search-inupt-container">
            <input a11y_Input id="locationSearcInput" type="text" [placeholder]="setPlaceHolder()" class="ya-input-text"
              (keyup)="searchLocationFilter($event, $event.target.value)" (blur)="setWebView()"
              [value]="searchLocationKey">
          </div>
          <a matRipple [matRippleDisabled]="true">
            <div class="content-list">
              <ng-container *ngIf="locationList.length>0">
                <div [ngClass]="locationList.length>1?'list-item--grid':'list-item--center'">
                  <ng-container *ngFor="let location of locationList; let i = index">
                    <div class="location-item" [class.item-animated]="animateItemOnSearchFilter"
                      (click)="selectLocation(location)">
                      <ng-container *ngIf="location.like">
                        <div class="location-like-wrapper">
                          <div class="inline-icon location-like-icon" inlineSVG="shop-icons.svg#ya-hypersoft-herz-voll">
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="getHasImage(location.image_photo)">
                        <div class="location-image">
                          <div class="aspect-ratio-box">
                            <div class="aspect-ratio-box-inside">
                              <div class="aspect-ration-img-box">
                                <img class="ya_image" [src]="location.image_photo" alt="" />
                              </div>
                            </div>
                          </div>
                          <div class="gradient"></div>
                        </div>
                      </ng-container>
                      <div class="list-item__content location-content">
                        <h3>{{location.label}}</h3>
                        <div class="list-item__label">
                          <span>{{location.street}}</span>
                          <div class="location-item__info">
                            <span>{{location.zipCode}}</span>
                            <span class="city">{{location.location}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </a>
        </mat-tab>
        <mat-tab label="{{orderTypeTabLabel}}" [disabled]="!isOrderTypeTabActive">
          <div class="tab__description">
            <ng-container
              *ngIf="isOrderTypeTabActive &&(ordertypes$ | async).length>0;then tabDescription else emptyTabDescription"></ng-container>
            <ng-template #tabDescription>
              <span>{{dialogTabDescription(dialogData.redeemType)}}</span>
            </ng-template>
            <ng-template #emptyTabDescription>
              <span>{{dialogEmptyTabDescription(dialogData.redeemType)}}</span>
            </ng-template>
          </div>
          <a matRipple [matRippleDisabled]="true">
            <div class="content-list">
              <ng-container *ngIf=" ordertypes$ | async; let ordertypes">
                <div [ngClass]="ordertypes.length>1?'list-item--grid':'list-item--center'">
                  <ng-container *ngFor="let ordertype of ordertypes;">
                    <div class="orderType-item" (click)="setRequirementsAndClose(ordertype.id)">
                      <div class="list-item__content orderType-content">
                        <div class="inline-icon" inlineSVG="{{ordertype.iconFilename}}"></div>
                        <div class="list-item__label">
                          <h3>{{ordertype.label}}</h3>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </a>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>